import * as jQuery from 'jquery';

import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { CONSTANTS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { PrerollCreativeComponent } from '../preroll-creative/preroll-creative.component';

@Component({
	selector: 'app-ctv-creative-r1',
	styleUrls: ['./ctv-creative-r1.component.css'],
	templateUrl: './ctv-creative-r1.component.html'
})
export class CtvCreativeR1Component extends PrerollCreativeComponent implements OnInit, AfterViewInit {
	@Input() downloadconfig: string;
	@Input() sectiontitle: string;
	@Input() sectionclass: string;
	public downloadConfiguration: DownloadConfig;
	public isR8: boolean = false;
	public isR104: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef
	) {
		super(analyticsService, analyticsDataModel, cdr);
		this.hasData = false;
		this.showLoad = true;
		jQuery('#playBtn').show();
		jQuery('#pauseBtn').hide();
		this.requestData();
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version === 'R8' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		super.ngOnInit();
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	requestData(): void {
		setTimeout(() => {
			this.analyticsService.processCustomServiceRequest(this.key).subscribe((res: any) => {
				this.showLoad = false;
				if (res.success) {
					this.hasData = true;
					this.setData(res.data);
				} else {
					this.hasData = false;
				}
			});
		}, CONSTANTS.LOAD_TIME);
	}

	setDisplayIndexContent(getDisplayIndex: number): void {
		if (this.displayData) {
			if (this.displayData.length === 0) {
				this.setDisplayProperties = {
					click_rate: 0,
					clicks: 0,
					completion_rate: 0,
					impressions: 0,
					mp4: '',
					name: '',
					percent_rate_100: 0,
					percent_rate_25: 0,
					percent_rate_50: 0,
					percent_rate_75: 0,
					percent_value_100: 0,
					percent_value_25: 0,
					percent_value_50: 0,
					percent_value_75: 0,
					thumbnail: ''
				};
				jQuery('#volumeBtn').hide();
				jQuery('#muteBtn').hide();
			} else {
				let setImpressions = this.displayData[getDisplayIndex].impressions;
				let setClicks = this.displayData[getDisplayIndex].clicks;
				let setClick_rate = this.displayData[getDisplayIndex].click_rate;
				let set25PercentValue = this.displayData[getDisplayIndex]['25_percent_value'];
				let set25PercentRate = this.displayData[getDisplayIndex]['25_percent_rate'];
				let set50PercentValue = this.displayData[getDisplayIndex]['50_percent_value'];
				let set50PercentRate = this.displayData[getDisplayIndex]['50_percent_rate'];
				let set75PercentValue = this.displayData[getDisplayIndex]['75_percent_value'];
				let set75PercentRate = this.displayData[getDisplayIndex]['75_percent_rate'];
				let set100PercentValue = this.displayData[getDisplayIndex]['100_percent_value'];
				let set100PercentRate = this.displayData[getDisplayIndex]['100_percent_rate'];
				let completionRate = this.displayData[getDisplayIndex]['100_percent_rate'];
				let setMp4Link = this.displayData[getDisplayIndex].video_url;
				const setMediaFiles = this.displayData[getDisplayIndex].media_files;
				const setThumbnailLink = this.displayData[getDisplayIndex].thumbnail;
				if (setImpressions == null || setImpressions === '') {
					setImpressions = 0;
				}
				if (setClicks == null || setClicks === '') {
					setClicks = 0;
				}
				if (setClick_rate == null || setClick_rate === '') {
					setClick_rate = 0;
				}
				if (set25PercentValue == null || set25PercentValue === '') {
					set25PercentValue = 0;
				}
				if (set25PercentRate == null || set25PercentRate === '') {
					set25PercentRate = 0;
				}
				if (set50PercentValue == null || set50PercentValue === '') {
					set50PercentValue = 0;
				}
				if (set50PercentRate == null || set50PercentRate === '') {
					set50PercentRate = 0;
				}
				if (set75PercentValue == null || set75PercentValue === '') {
					set75PercentValue = 0;
				}
				if (set75PercentRate == null || set75PercentRate === '') {
					set75PercentRate = 0;
				}
				if (set100PercentValue == null || set100PercentValue === '') {
					set100PercentValue = 0;
				}
				if (set100PercentRate == null || set100PercentRate === '') {
					set100PercentRate = 0;
					completionRate = 0;
				}
				if (setMp4Link === null || setMp4Link === '') {
					setMp4Link = this.getMp4FromMediaFilesJson(setMediaFiles);
				}
				setClick_rate = parseFloat(setClick_rate).toFixed(2);
				set25PercentRate = parseFloat(set25PercentRate).toFixed(1);
				set50PercentRate = parseFloat(set50PercentRate).toFixed(1);
				set75PercentRate = parseFloat(set75PercentRate).toFixed(1);
				set100PercentRate = parseFloat(set100PercentRate).toFixed(1);
				completionRate = parseFloat(completionRate).toFixed(1);
				this.setDisplayProperties = {
					click_rate: setClick_rate,
					clicks: setClicks,
					completion_rate: completionRate,
					impressions: setImpressions,
					mp4: setMp4Link,
					name: this.displayData[getDisplayIndex].name,
					percent_rate_100: set100PercentRate,
					percent_rate_25: set25PercentRate,
					percent_rate_50: set50PercentRate,
					percent_rate_75: set75PercentRate,
					percent_value_100: set100PercentValue,
					percent_value_25: set25PercentValue,
					percent_value_50: set50PercentValue,
					percent_value_75: set75PercentValue,
					thumbnail: this.displayData[getDisplayIndex].thumbnail
				};
				if (this.setDisplayProperties.mp4) {
					jQuery('#volumeBtn').hide();
					jQuery('#muteBtn').show();
					jQuery('#playBtn').show();
					jQuery('#pauseBtn').hide();
					if (jQuery('#preRollvideo')[0]) {
						jQuery('#preRollvideo')[0].autoplay = true;
						jQuery('#preRollvideo')[0].muted = true;
					}
					jQuery('#videoDisplayblock').show();
				} else {
					jQuery('#volumeBtn').hide();
					jQuery('#muteBtn').hide();
					jQuery('#playBtn').hide();
					jQuery('#pauseBtn').hide();
					jQuery('#videoDisplayblock').hide();
				}
			}
		}
	}

	downloadDataInCSV(event: any): void {
		event.preventDefault();
		const qkey = this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key;
		this.analyticsService.downloadCSV(qkey, this.downloadConfiguration.fileName, this.downloadCSVColumns);
	}
}
